import { FormControl, FormGroup } from "@angular/forms";
import { Patient } from "src/app/modules/patient/models/patient.model";
import { SessionData } from "./session-data.model";
import { SessionCancellationReason } from "./session-cancellation-reason.model";

/**************************
***** MODEL DEFINITION ****
***************************/
export class Session {
    public id: string;
    public patient: Patient;
    public dateStart: Date;
    public hourStart: Date;
    public numSession: number;
    public numWeekSession: number;
    public duration: number;
    public sessionName: string;
    public sessionType: string;
    public onlineMeetingURL: string;
    public onlineMeetingPhone: string;
    public status: string;
    public statusPatient: string;
    public sessionsData: SessionData[];
    public cancellationReason: string;
    public cancellationReasonSpecific: SessionCancellationReason;
}

export enum SessionCancellationType {
    non_compliance = 'Incumplimiento',
    early_termination = 'Finalización prematura',
}


/*****************************
***** FORMGROUP INTERFACE ****
******************************/
export interface SessionForm {
    info?: FormGroup<SessionInfoForm>;
}

export interface SessionInfoForm {
    patient: FormControl<string | null>;
    dateStart: FormControl<Date | null>;
    hourStart: FormControl<Date | null>;
    numSession: FormControl<number | null>;
    numWeekSession: FormControl<number | null>;
    duration: FormControl<number | null>;
    sessionName: FormControl<string | null>;
    onlineMeetingURL: FormControl<string | null>;
    onlineMeetingPhone: FormControl<string | null>;
    duplicateSessionFrom: FormControl<string | null>;
    sessionType: FormControl<string | null>;
    status: FormControl<string | null>;
}